<template>
    <div class='staff-list'>
        <div class="search-wrapper">
            <el-button type="primary" @click="addStaff">+添加员工</el-button>
            <!-- <more-operate :width="'auto'">
                <div class="operate-detail-item">
                    <router-link class="href color-333"
                        :to="'/main/staff/permissionSet'">编辑员工角色权限</router-link>
                </div>
            </more-operate> -->
            <my-search :styleData="{
                placeholder: '输入员工姓名/手机号',
                width: '248px',
                height: '36px'
            }"  @searchData="searchData"/>
        </div>
        <el-table v-loading="isFullLoading"
            v-textHighlight="{
                keyword: oKeyword,
                indexs: [1, 2],
                isBegin: !isFullLoading
            }"
            ref="elTable"
            :data="staffList"
            :height="'calc(100vh - 142px)'"
            style="width: 100%">
            <el-table-column
                type="index"
                label="#"
                width="50">
            </el-table-column>
            <el-table-column
                label="姓名"
                min-width="280">
                <template v-slot="{ row }">
                    <div class="fx-v-center">
                        <user-info :userInfo="row.user" />
                        <div v-if="row.permission_list.includes(0)" class="common-role super-admin ml-4">{{ '超级管理员' }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="手机号"
                min-width="120">
                <template v-slot="{ row }">
                    <p>{{ row.user && row.user.phone }}</p>
                </template>
            </el-table-column>
            <!-- <el-table-column
                label="角色"
                min-width="230">
                <template v-slot="{ row }">
                    <div v-if="row.permission_list.includes(0)"
                        class="fx-v-center role-wrapper">
                        <div class="common-role super-admin">{{ '超级管理员' }}</div>
                    </div>
                    <p v-else>-</p>
                </template>
            </el-table-column> -->
            <el-table-column
                label="操作"
                min-width="110">
                <template v-slot="{ row }">
                    <!-- <button
                        class="text-btn pl-0"
                        @click="editStaffInfo(row)"
                    >编辑</button> -->
                    <button class="text-btn" @click="$router.push('/main/staff/staffDetail?id=' + row.id)">详情</button>
                </template>
            </el-table-column>
            <template slot="empty">
                <div v-if="!isFullLoading">
                    <img src="./images/no-staff.svg" alt="" style="width: 110px">
                    <p style="line-height: 1; color: #666">
                        <span>暂无员工，</span><span class="href" @click="addStaff">去添加</span>
                    </p>
                </div>
                <p v-else></p>
            </template>
            <p v-if="isHasMore && isLoading" slot="append" style="text-align: center; padding: 10px;">
                <span class="loading-step-animation">正在加载...</span>
            </p>
            <p v-if="(!isHasMore) && staffList.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
        </el-table>
        <!-- components -->
        <add-staff
            :visible.sync="isShowAddStaff"
            :headerTitle="'添加员工'"
            :content="'邀请员工微信扫码提交申请，管理员在后台通过申请即可添加员工。'"
            :qrcodeSrc="qrcodeSrc"
            :qrcodeDes="'扫一扫成为员工'"/>
        <edit-and-add-staff-info
            :visible.sync="isShowEditStaff"
            :mode="'update'"
            :staffId="curStaffId"
            :confirmCallback="editCallback"
            :deleteCallback="editCallback"/>
    </div>
</template>

<script lang='ts'>
import { createComponent, ref, onBeforeMount, onMounted } from '@vue/composition-api'
import MySearch from '@/components/search/search.vue'
import AddStaff from '../modules/add_staff.vue'
import EditAndAddStaffInfo from '../modules/edit_and_add_staff_info.vue'
// import MoreOperate from '@/components/more_operate/more_operate.vue'
import $fetch from '@/api/index'
import { openMessage, useScrollLoad } from '../../../utils/system'
import clone from 'lodash/cloneDeep'
import QRCode from 'qrcode'
import domain from '@/config/domain.ts'

export default createComponent({
    setup(props, ctx) {
        const oKeyword = ref('')
        const isShowAddStaff = ref(false)
        const isShowEditStaff = ref(false)
        const isFullLoading = ref(false)
        const qrcodeSrc = ref<string>('')
        const curStaffId = ref<number>(0)
        const staffList = ref<any[]>([])
        const {
            page: oPage,
            isHasMore,
            isLoading,
            bindListener,
            initScrollLoad
        } = useScrollLoad()

        const store = ctx.root.$store
        const oLimit = 20

        onBeforeMount(() => {
            getQRCodeSrc()
            getStaffList()
        })

        onMounted(() => {
            bindListener({
                dom: (ctx.refs.elTable as any).$el.querySelector('.el-table__body-wrapper'),
                loadFunction: getStaffList
            })
        })

        function getQRCodeSrc() {
            const shopId = store.state.shop.shopInfo.id
            QRCode.toDataURL(`${domain.cashierMobile}#/employess/registe?shopId=${shopId}`, (err, url) => {
                if  (err) {
                    return openMessage('error', '生成二维码失败')
                }
                qrcodeSrc.value = url
            })
        }

        function getStaffList(page = oPage.value, limit = oLimit, keyword = oKeyword.value) {
            isFullLoading.value = true
            return $fetch.post({
                url: '/staff/getstafflist',
                params: {
                    page,
                    limit,
                    status: 0,
                    keyword: keyword || undefined
                }
            }).then(result => {
                console.log('员工列表', clone(result))
                if (page === 1) {
                    staffList.value = []
                    ctx.root.$nextTick(() => {
                        staffList.value = result.staff_list
                        initScrollLoad(result)
                    })
                } else {
                    staffList.value = staffList.value.concat(result.staff_list)
                }
                return result
            }).catch(e => {
                openMessage('error', e.message || '获取员工列表失败')
            }).finally(() => {
                isFullLoading.value = false
            })
        }

        function addStaff() {
            isShowAddStaff.value = true
        }

        function searchData(keywords: string, type: string) {
            oKeyword.value = keywords
            oPage.value = 1
            getStaffList()
        }

        function editStaffInfo(row: { [propName: string]: any }) {
            curStaffId.value = row.id
            isShowEditStaff.value = true
        }

        function editCallback() {
            if (oPage.value === 1) {
                getStaffList()
            } else {
                staffList.value = staffList.value.slice(0, - oLimit)
                getStaffList()
            }
        }

        return {
            // data
            isHasMore,
            isLoading,
            isFullLoading,
            isShowAddStaff,
            isShowEditStaff,
            staffList,
            qrcodeSrc,
            curStaffId,
            oKeyword,
            // methods
            searchData,
            addStaff,
            editStaffInfo,
            editCallback
        }
    },
    components: {
        MySearch,
        AddStaff,
        EditAndAddStaffInfo,
        // MoreOperate
    }
})
</script>

<style lang="scss" scoped>
.operate-detail-item {
    color: #333;
    height: 36px;
    line-height: 36px;
    padding: 0 8px;

    &:hover {
        background: #F7F7F7;
    }

    span {
        flex: none;
    }
}

.staff-list {
    position: relative;

    .search-wrapper {
        position: absolute;
        right: 0;
        top: -54px;
        display: flex;
        align-items: center;

        ::v-deep .el-button {
            width: 100px;
            margin-right: 12px;
            padding-left: 0;
            padding-right: 0;
            text-align: center;
            box-sizing: border-box;
        }
    }
}
</style>
